// NOTE: NSAI-5941 / NSAI-5942 — query keys shared by web and mobile. They must
// be the same string on both clients: a mutation on one screen invalidates the
// key, and a second copy of the literal would leave one platform's cache stale
// after the other's write.
export const PII_SETTINGS_QUERY_KEY = "organization-pii-settings";

export const PII_CUSTOM_ENTITIES_QUERY_KEY = "organization-pii-custom-entities";

export const PII_CUSTOM_ENTITY_LABELS_QUERY_KEY =
  "organization-pii-custom-entity-labels";

// NOTE: The confidence slider's bounds, mirrored from web's PiiEntityRulesSection.
// Below 0.1 the detector matches almost anything; above 0.95 it effectively
// stops firing, so neither end is a useful place to leave an org.
export const PII_SCORE_THRESHOLD_MIN = 0.1;
export const PII_SCORE_THRESHOLD_MAX = 0.95;
export const PII_SCORE_THRESHOLD_STEP = 0.05;
// NOTE: The server's DEFAULT_SCORE_THRESHOLD (0.4 since NSAI-6525), for a
// response that carries no effective threshold. Keep the two equal, or the
// slider shows an org on defaults a value the detector is not using.
export const PII_SCORE_THRESHOLD_FALLBACK = 0.4;

export const PII_CUSTOM_ENTITY_DEFAULT_SCORE = 0.85;

// NOTE: Financial masking strictness levels, mirrored from web's
// FinancialMaskingSection. Not an enum because the server stores and returns a
// plain string column and treats an unknown value as BALANCED.
export const FINANCIAL_MASKING_STRICTNESS_OPTIONS = [
  "permissive",
  "balanced",
  "strict",
  "on_prem",
] as const;

export const FINANCIAL_MASKING_DEFAULT_STRICTNESS = "balanced";
